/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InfoList } from '../../models/info-list';

export interface GetProductionOrderInfos$Params {
  workCenterId: number;
  approvalReportDate: string;
  productionOrderId: number;
}

export function getProductionOrderInfos(http: HttpClient, rootUrl: string, params: GetProductionOrderInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<InfoList>> {
  const rb = new RequestBuilder(rootUrl, getProductionOrderInfos.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('approvalReportDate', params.approvalReportDate, {});
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InfoList>;
    })
  );
}

getProductionOrderInfos.PATH = '/api/v1/workCenter/{workCenterId}/approvals/{approvalReportDate}/productionOrders/{productionOrderId}/info';
